<template>
  <v-dialog v-model="model" max-width="100%" fullscreen scrollable persistent>
    <v-card id="korisnici-za-stampu">
      <v-card-title class="primary" style="width: 100%">
        <span
          style="font-size: 18px !important; justify-content: space-between; width: 100%"
          class="headline white--text text-center d-flex no-print"
        >
          <span>
            {{ toLatin(restaurantName) }} -
            <span class="text-lowercase">{{ $t("add_worker") }}</span></span
          >
          <v-spacer></v-spacer>

          <employee-button-print
            color="white"
            :employees="multipleUsers"
            :headers="headersForPrint"
            :subtitle="parentCompany?.name || ''"
          ></employee-button-print>
          <circle-button
            @click="model = false"
            :small="false"
            class="ml-2"
            icon="mdi-close"
          ></circle-button>
        </span>
      </v-card-title>
      <v-card-text>
        <company-employee-quick-add-info-dialog
          v-if="addedMultipleUsersData"
          :employees="addedMultipleUsersData"
          :restaurant-name="restaurantName"
          :parent-company="parentCompany"
        ></company-employee-quick-add-info-dialog>
        <div class="mt-4" v-else>
          <v-form v-model="valid">
            <v-row v-for="(usr, index) in multipleUsers" :key="index" align="center">
              <span class="pr-2 block">{{ index + 1 }}. </span>
              <v-col class="py-0">
                <text-field
                  v-model="usr.name"
                  required
                  :rules="[rules.required]"
                  :label="$t('name')"
                ></text-field>
              </v-col>
              <v-col class="py-0">
                <text-field
                  v-model="usr.lastname"
                  required
                  :rules="[rules.required]"
                  :label="$t('last_name')"
                ></text-field>
              </v-col>
              <v-col class="py-0">
                <text-field
                  v-model="usr.email"
                  required
                  :rules="[rules.required]"
                  :label="$t('email_or_username')"
                ></text-field>
              </v-col>
              <v-col class="py-0">
                <text-field
                  v-model="usr.password"
                  required
                  :type="passwordType"
                  :rules="[rules.required]"
                  :label="$t('password')"
                ></text-field>
              </v-col>
              <v-col class="py-0">
                <employee-role-picker v-model="usr.type" :company="selectedCompany" />
              </v-col>
              <template v-if="usr.type === 'recipient'">
                <v-col class="py-0">
                  <v-switch
                    v-model="usr.is_contract"
                    inset
                    :label="$t('is_contract')"
                    :false-value="0"
                    :true-value="1"
                    dense
                  ></v-switch>
                </v-col>
                <v-col class="py-0">
                  <v-switch
                    v-model="usr.is_non_contract"
                    inset
                    :label="$t('is_non_contract')"
                    :false-value="0"
                    :true-value="1"
                    dense
                  ></v-switch>
                </v-col>
              </template>
              <v-card flat v-if="usr.type == 'recipient'">
                <autocomplete
                  v-model="searchs"
                  multiple
                  :items="(parentCompanies || []).filter((i) => i.name)"
                  :label="$t('choose_office')"
                  item-text="name"
                  item-value="id"
                  clear
                  chips
                  :hide-details="false"
                  small-chips
                  select-all
                />
              </v-card>
              <v-col class="py-0">
                <text-field
                  v-model="usr.external_code"
                  :label="$t('external_code')"
                ></text-field>
              </v-col>
              <remove-button @click="removeNewUser(index)"></remove-button>
            </v-row>
          </v-form>
          <v-row no-gutters justify="end">
            <v-btn color="success" dark fab small @click.prevent="addNewUser">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-row>
        </div>
      </v-card-text>
      <v-card-actions class="no-print">
        <v-spacer></v-spacer>
        <v-btn text @click="model = false">
          <span>{{ $t("cancel") }}</span>
        </v-btn>
        <v-btn
          v-if="!addedMultipleUsersData"
          color="tertiary"
          :dark="valid"
          depressed
          :loading="loading"
          :disabled="!valid"
          @click.prevent="multipleUserAdd()"
        >
          <span>{{ $t("save") }}</span>
        </v-btn>
        <v-btn
          v-else
          color="tertiary"
          dark
          depressed
          @click.prevent="
            multipleUsers = [{ ...defaultEmployee }];
            addedMultipleUsersData = null;
          "
        >
          <span>{{ $t("add") }} {{ $t("more") }}</span>
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import hasValidation from "@/mixins/hasValidation";
import hasSnackbar from "@/mixins/hasSnackbar";
import CompanyEmployeeQuickAddInfoDialog from "./CompanyEmployeeQuickAddInfoDialog.vue";
import EmployeeButtonPrint from "@/components/company/employee/buttons/EmployeeButtonPrint.vue";
import { defaultEmployee } from "@/models/employee";
import employeeService from "@/services/employee";
import EmployeeRolePicker from "@/components/company/fields/EmployeeRolePicker.vue";

export default {
  name: "CompanyEmployeeQuickAddDialog",
  mixins: [hasModel, hasValidation, hasSnackbar],
  components: {
    CompanyEmployeeQuickAddInfoDialog,
    EmployeeButtonPrint,
    EmployeeRolePicker,
  },
  props: {
    restaurantName: {
      type: String,
      default: "",
    },
    selectedCompany: {
      type: Object,
      required: false,
    },
    parentCompany: {
      type: Object,
      default: () => ({}),
    },
    parentCompanies: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      searchs: [],
      multipleUsers: [],
      addedMultipleUsersData: null,
      loading: false,
      selectedQrSecret: null,
      defaultEmployee,
      passwordType: "text",
    };
  },
  created() {
    this.addNewUser();
  },
  computed: {
    headersForPrint() {
      return [
        {
          text: this.$t("name"),
          value: "name",
        },
        {
          text: this.$t("last_name"),
          value: "lastname",
        },
        {
          text: this.$t("email"),
          value: "email",
        },
        {
          text: "Code",
          value: "external_code",
        },
        {
          text: this.$t("password"),
          value: "password",
        },
        {
          text: this.$t("user_type"),
          value: "type",
        },
      ];
    },
    userTypeItems() {
      if (this.$route.name === "restoran-id-korisnici") {
        return [
          { text: this.$t("restaurant"), val: "restaurant" },
          {
            text: this.$t("qr_scanner_order_division"),
            val: "payment",
          },
          { text: this.$t("reports_worker_orders"), val: "report" },
          {
            text: this.$t("reports_guest_orders"),
            val: "report_guest",
          },
          { text: this.$t("stock"), val: "warehouse" },
          { text: this.$t("table"), val: "table" },
          // {text:this.$t('delivery1'),val:'delivery'}
        ];
      } else if (
        this.$route.params.delivery &&
        this.$route.params.delivery === "dostava"
      ) {
        return [
          { text: this.$t("delivery_person"), val: "dostava" },
          { text: this.$t("admin_delivery"), val: "admin_delivery" },
        ];
      } else {
        return [
          { text: this.$t("worker"), val: "customer" },
          { text: this.$t("company_administrator"), val: "company" },
          {
            text: this.$t("meal_reception_delivery"),
            val: "recipient",
          },
          { text: this.$t("guest"), val: "guest" },
          { text: this.$t("table"), val: "table" },
        ];
      }
    },
  },
  methods: {
    removeNewUser(index) {
      this.multipleUsers.splice(index, 1);
    },
    async multipleUserAdd() {
      this.loading = true;
      try {
        const { data } = await employeeService.addMultipleUsers(
          this.$route.params.id || this.$store.state.company.id,
          this.multipleUsers
        );
        if (data) {
          this.addedMultipleUsersData = {
            new_users: Array.isArray(data.data.new_users)
              ? data.data.new_users
              : Object.values(data.data.new_users),
            existing_users: Array.isArray(data.data.existing_users)
              ? data.data.existing_users
              : Object.values(data.data.existing_users),
          };
          (this.addedMultipleUsersData.new_users || []).forEach((user) => {
            user.password = this.multipleUsers.find(
              (item) => item.email === user.email
            ).password;
            this.$emit("employeeAdded", user);
          });
          this.showSuccessSnackbar(
            this.$t("users_added_successfully") ||
              `${this.addedMultipleUsersData.new_users.length} korisnika uspešno dodato`
          );
        }
      } catch (error) {
        this.showErrorSnackbar(
          this.$t("users_add_failed") || "Greška pri dodavanju korisnika"
        );
      } finally {
        this.loading = false;
      }
    },
    addNewUser() {
      this.multipleUsers.push({
        ...defaultEmployee,
      });
    },
  },
};
</script>
